<lib-card [fullScreenMode]="false">
  <lib-card-header>
    <ul class="nav d-flex align-items-center">
      <li class="nav-item font-weight-bold text-primary font-size-normal">
        {{"PERFORMANCE_FACTS.PERFORMANCE_FACTS" |translate}}
      </li>
      <li class="nav-item mr-3" >
        <app-spinner [show]="!facts || facts?.showSpinner"></app-spinner>
      </li>
      <!-- <li class="nav-item mr-3 text-primary" *ngIf="facts?.LPHD1_PhyHealth_stVal">
      {{"PERFORMANCE_FACTS.HEALTH" |translate}}: <b>{{ facts?.LPHD1_PhyHealth_stVal| healthCode : 'name' }}</b>
    </li>
    <li class="nav-item mr-3 text-primary" *ngIf="facts?.WTUR1_TurSt_actSt_stVal">
      {{"PERFORMANCE_FACTS.TURBINE_STATUS" |translate}}: <b> {{ facts?.WTUR1_TurSt_actSt_stVal | monitorAlarm : 'name'
    }} </b>
  </li> -->
  @if (facts?.WNAC1_WdSpd_mag_f) {
    <li class="nav-item text-primary">
      {{"PERFORMANCE_FACTS.MEASURED_WIND_SPEED" |translate}}: <b> {{ facts?.WNAC1_WdSpd_mag_f }} m/s </b>
    </li>
  }

  <li class="nav-item ml-sm-auto">
    @if (facts?.totalSignalCount && facts?.availableSignalCount) {
      <div class="text-primary font-size-small">
        {{"PERFORMANCE_FACTS.DATA_FROM" |translate}} {{ facts?.availableSignalCount }} {{"PERFORMANCE_FACTS.OUT_OF"
        |translate}}
        {{ facts?.totalSignalCount }} {{"PERFORMANCE_FACTS.TURBINES_AT" |translate}}
        {{ facts?.dataAquisitionMax | dateTimeFormatPipe: 'dmt': tz.selectedOption: '(z)'}}
      </div>
    }
  </li>
</ul>
</lib-card-header>
<lib-card-body>
  <div class="row d-flex justify-content-start align-items-end {{theme$ | async}} p-md-3 p-xl-4">
    <!-- actual power -->
    <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
      <lib-standard-kpi [size]="'large'" [digitsInfo]="digits" [comma]="true"
        [kpi]="{value: facts?.actual_power, displayName: 'PERFORMANCE_FACTS.TOTAL_ACTPOWER' | translate, unit: unitOfMeasure}"
      [image]="(image$ | async)?.actual" [lessThanOneSpecialDisplay] = "lessThanOneSpecialDisplay"></lib-standard-kpi>
    </div>
    <!-- theoretical power -->
    <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
      <lib-standard-kpi [size]="'large'" [digitsInfo]="digits" [comma]="true"
        [kpi]="{value: facts?.theoretical_power, displayName: 'PERFORMANCE_FACTS.TOTAL_THEOPOWER' | translate, unit: unitOfMeasure}"
      [image]="(image$ | async)?.theo"></lib-standard-kpi>
    </div>
    <!-- rated power -->
    <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
      <lib-standard-kpi [size]="'large'" [digitsInfo]="digits" [comma]="true"
        [kpi]="{value: facts?.rated_power, displayName: 'PERFORMANCE_FACTS.TOTAL_RATEDPOWER' | translate, unit: unitOfMeasure}"
      [image]="(image$ | async)?.rate"></lib-standard-kpi>
    </div>
    <!-- power loss -->
    <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
      <lib-standard-kpi [size]="'large'" [digitsInfo]="digits" [comma]="true"
        [kpi]="{value: facts?.power_loss, displayName: 'PERFORMANCE_FACTS.TOTAL_LOSS' | translate, unit: unitOfMeasure}"
      [image]="(image$ | async)?.loss"></lib-standard-kpi>
    </div>
    <!-- load factor -->
    <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
      <app-load-factor-highchart
        [colors]="colors?.[0]?.backgroundColor"
        [loadFactor]="facts?.WTUR1_per_loadFactor ? facts.WTUR1_per_loadFactor * 100 : null"
        [digitsInfo]="digits">
      </app-load-factor-highchart>
    </div>
    <!-- efficiency -->
    @if (!facts?.noEfficiency) {
      <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
        <lib-bar-chart-kpi
          [colors]="['primary-background', 'charts-background']"
          [digitsInfo]="digits" [size]="'large'"
          [kpi]="{value: facts?.WTUR1_per_efficiency, displayName: ('PERFORMANCE_FACTS.EFFICIENCY' |translate)}">
        </lib-bar-chart-kpi>
      </div>
    }
    <!-- budget -->
    @if (!isTurbine && validBudget) {
      <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
        <app-tachometer-chart
          [budgetData]="budgetData"
          [budget]="budgetData?.budget_actual"
          [revenues]="budgetData?.budget_budget"
          [annualbudget]="budgetData?.annualbudget"
          [ytdactual]="budgetData?.ytdactual"
          [ytdbudget]="budgetData?.ytdbudget"
          [colors]="colors?.[0]?.backgroundColor">
        </app-tachometer-chart>
      </div>
    }

    <!-- active alarms -->
    @if (!isTurbine && showAlarmCount) {
      <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0 performance-facts-alarm-kpi">
        <i class="far fa-bell text-primary performance-facts-alarm-icon" aria-hidden="true"></i>
        <lib-standard-kpi [size]="'large'"
          [kpi]="{value: data?.openAlarms, displayName: 'ALARMS.ACTIVE_ALARMS' | translate}"></lib-standard-kpi>
      </div>
    }

    <!-- turbine health -->
    @if (isTurbine) {
      <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
        <div class="large-container">
          @if (facts?.LPHD1_PhyHealth_stVal != null) {
            <i
              [class]="'mr-3 status-icon ' + (facts?.LPHD1_PhyHealth_stVal | healthCode : 'icon')"
              [style.color]="facts?.LPHD1_PhyHealth_stVal | healthCode : 'color'"
              [attr.aria-label]="'IMAGE_DESCRIPTION.HEALTH_EVENT' | translate"
              role="img"></i>
          }
          <div>
            @if (facts?.LPHD1_PhyHealth_stVal != null) {
              <div class="font-weight-bold font-size-normal text-primary">
                {{ facts?.LPHD1_PhyHealth_stVal | healthCode : 'name' }}
              </div>
            }
            @if (facts?.LPHD1_PhyHealth_stVal == null) {
              <div class="font-weight-bold font-size-very-small text-primary">
                {{ '-' }}
              </div>
            }
            <div class="font-size-very-small">
              {{ 'MONITOR.TURBINE.TURBINE_COCKPIT_EVENTS.HEALTH' | translate }}
            </div>
          </div>
        </div>
      </div>
    }

    <!-- turbine status -->
    @if (isTurbine) {
      <div class="col-12 col-sm-6 col-md-3 col-xl flex-grow-1 pt-0">
        <div class="large-container">
          @if (facts?.WTUR1_TurSt_actSt_stVal != null) {
            <div class="mr-3 turbine-icon-wrapper">
              <app-turbine-icon [color]="facts?.WTUR1_TurSt_actSt_stVal | monitorAlarm : 'color'"></app-turbine-icon>
            </div>
          }
          <div>
            @if (facts?.WTUR1_TurSt_actSt_stVal != null) {
              <div class="font-weight-bold font-size-normal text-primary">
                {{ facts?.WTUR1_TurSt_actSt_stVal | monitorAlarm : 'name' }}
              </div>
            }
            @if (facts?.WTUR1_TurSt_actSt_stVal == null) {
              <div class="font-weight-bold font-size-very-small text-primary">
                {{ '-' }}
              </div>
            }
            <div class="font-size-very-small">
              {{ 'MONITOR.TURBINE.TURBINE_COCKPIT_EVENTS.TURBINE_STATUS' | translate }}
            </div>
          </div>
        </div>
      </div>
    }
  </div>
</lib-card-body>
</lib-card>
